import { type Order } from '@prisma/client'

export const eurExchangeRate = 24

export const prices = {
	basicCard: {
		0: 0,
		9: 33,
		18: 27,
		27: 25,
		36: 24,
		50: 20,
	},
	a4Card: (count: number) => {
		switch (count) {
			case 1:
				return 150
			case 2:
				return 130
			default:
				return 125
		}
	},
	a3Card: (count: number) => {
		switch (count) {
			case 1:
				return 290
			default:
				return 250
		}
	},
	a4GroupCard: 150,
	a3GroupCard: 250,
}

export const getTotalPrice = ({
	basicCardsCount,
	a3CardsCount,
	a4CardsCount,
	a3GroupCardsCount,
	a4GroupCardsCount,
}: Pick<
	Order,
	| 'basicCardsCount'
	| 'a3CardsCount'
	| 'a4CardsCount'
	| 'a3GroupCardsCount'
	| 'a4GroupCardsCount'
>) => {
	let price = 0

	const basicCardItemPrice = (prices.basicCard as any)[basicCardsCount]
	price += basicCardItemPrice * basicCardsCount

	const a3CardItemPrice = prices.a3Card(a3CardsCount)
	price += a3CardItemPrice * a3CardsCount

	const a4CardItemPrice = prices.a4Card(a4CardsCount)

	price += a4CardItemPrice * a4CardsCount

	price += prices.a4GroupCard * a4GroupCardsCount

	price += prices.a3GroupCard * a3GroupCardsCount

	if (basicCardsCount >= 18) {
		price -= 150
	}

	return Number(price.toFixed(2))
}
